import classNames from "classnames/bind";
import TrimOptionIcon from "common/blocks/TrimOptionIcon";
import type { ResolvedIconList } from "resolvers/data/iconListResolver";
import styles from "./ArticleCarFeatures.module.scss";

const cx = classNames.bind(styles);

const ArticleCarFeatures = (props: ResolvedIconList) => (
    <ul className={cx("grid")}>
        {props.iconList.map((feature, i) => (
            <li className={cx("feature")} key={i}>
                <div className={cx("iconWrapper")}>
                    <TrimOptionIcon icon={feature.icon} />
                </div>
                <p className={cx("description")}>{feature.label}</p>
            </li>
        ))}
    </ul>
);

export default ArticleCarFeatures;
